import ApiService from "./ApiService";

export async function apiLogin(data) {
  return ApiService.fetchData({
    url: "/user/auth/login",
    method: "post",
    data,
  });
}
